<script setup>
import { defineProps, defineEmits, ref } from 'vue'

const props = defineProps({
    items: {
        type: Array,
        required: true
    },
    loading: {
        type: Boolean,
        default: false
    }
})

const emits = defineEmits(['item-selected'])

const expandedItem = ref(null)

const selectItem = (item) => {
    if (props.loading) return

    emits('item-selected', item.value)
}

const selectSubItem = (parent, type) => {
    emits('item-selected',
        parent.value)
}

</script>

<template>
    <div class="card-selector">
        <v-row>
            <v-col
                v-if="loading"
                cols="12"
                class="d-flex justify-center align-center"
            >
                <v-progress-circular indeterminate color="primary" size="48" />
            </v-col>

            <template v-else>
                <v-col
                    v-for="(item, index) in items"
                    :key="index"
                    cols="12"
                    sm="6"
                    md="4"
                    lg="12"
                    class="d-flex flex-column"
                >
                    <!-- CARD PRINCIPAL -->
                    <v-card
                        class="flex-grow-1 p-0"
                        @click="selectItem(item)"
                        elevation="1"
                    >
                        <v-card-text class="text-center">
                            <div class="d-flex justify-space-between align-center">
                                <span class="text-subtitle-1 text-black">
                                    {{ item.name }}
                                </span>

                                <v-icon>
                                    {{ expandedItem === item.name ? 'mdi-chevron-down' : 'mdi-chevron-right' }}
                                </v-icon>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-col>
            </template>
        </v-row>
    </div>
</template>
